import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import {
  createObjReq,
  menteeObjectiveProps,
  updateObjReq,
  ErrorResponseType,
  ObjectiveReport,
} from '../types';
import { errMsg, errMsgNoData } from '../helper/functions';

const createObj = import.meta.env.VITE_CREATE_OBJ;
const getAllObj = import.meta.env.VITE_GET_ALL_OBJ;
const updateObj = import.meta.env.VITE_UPDATE_OBJ;
const getObj = import.meta.env.VITE_GET_OBJ;
const getAuditCode = import.meta.env.VITE_GET_AUDIT;
const getObjectiveReport = import.meta.env.VITE_GET_OBJECTIVES_REPORT;
const getObjectiveWithFeedbackCode = import.meta.env.VITE_GET_OBJ_WITH_FEEDBACK;

// objective apis
export const createObjective = async (payload: createObjReq) => {
  const data = { ...payload };
  const ret: { error: ErrorResponseType | null } = { error: null };
  try {
    await axios.post(`${apiPaths.objective}?code=${createObj}`, data);
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getAllObjectives = async (
  mentee: string,
  mode?: 'mentor' | 'hr',
  quarterID?: string
) => {
  const ret: { data: menteeObjectiveProps[]; error: ErrorResponseType | null } =
    {
      error: null,
      data: [],
    };
  try {
    const { data } = await axios.get(
      `${apiPaths.objective}?mentee=${mentee}${mode ? `&mode=${mode}` : ''}&code=${getAllObj}${quarterID ? `&quarterId=${quarterID}` : ''}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const updateObjectives = async (payload: updateObjReq, id: string) => {
  const req = { ...payload };
  const ret: { data: menteeObjectiveProps[]; error: ErrorResponseType | null } =
    {
      error: null,
      data: [],
    };
  try {
    const { data } = await axios.put(
      `${apiPaths.objective}/${id}?code=${updateObj}`,
      req
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getObjective = async (id: string) => {
  const ret: { data?: menteeObjectiveProps; error: ErrorResponseType | null } =
    {
      error: null,
    };
  try {
    const { data } = await axios.get(
      `${apiPaths.objective}/${id}?code=${getObj}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getObjectiveWithFeedback = async (
  menteeId: string,
  quarterId: string
) => {
  const ret: {
    data?: menteeObjectiveProps[];
    error: ErrorResponseType | null;
  } = {
    error: null,
    data: [],
  };

  try {
    const { data } = await axios.get(
      `${apiPaths.objective}?mentee=${menteeId}&quarterId=${quarterId}&code=${getObjectiveWithFeedbackCode}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getAudit = async (id: string) => {
  const ret: { error: ErrorResponseType | null; data: any[] } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.auditTrails}/${id}?code=${getAuditCode}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getObjectivesReport = async () => {
  const ret: { data?: ObjectiveReport[]; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.objectivesReport}?code=${getObjectiveReport}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
